module.exports = __webpack_public_path__ + "img/rend_03.9ea5ba12.png";